import { BOH_TRANSACTIONS_EDIT_REQUEST, BOH_TRANSACTIONS_EDIT_SUCCESS, BOH_TRANSACTIONS_EDIT_FAILURE } from './types/BalanceModificationTransactionsEditActionsTypes';

export function putBOHTransactionsEditRequestActionCreator(context,
  newAdjustment,
  newComments,
  newDescription,
  newEffectiveDateTime,
  newImpcCode,
  newOperatorCode,
  newTransactionId) {
  return {
    type: BOH_TRANSACTIONS_EDIT_REQUEST,
    payload: {
      appContext: context,
      params: {
        adjustment: newAdjustment,
        comments: newComments,
        description: newDescription,
        effectiveDateTime: newEffectiveDateTime,
        impcCode: newImpcCode,
        operatorCode: newOperatorCode,
        transactionId: newTransactionId,
      },
    },
  };
}

export function putBOHTransactionsEditSuccessActionCreator(data) {
  return {
    type: BOH_TRANSACTIONS_EDIT_SUCCESS,
    payload: data,
  };
}

export function putBOHTransactionsEditFailureActionCreator(error) {
  return {
    type: BOH_TRANSACTIONS_EDIT_FAILURE,
    payload: error,
    error: true,
  };
}
